import { FooterLinkType } from '../services/helpCenter';
import useFetchHelpCenter from './fetch/useFetchHelpCenter';

export default function useFooterLinks() {
  const { data: helpCenter } = useFetchHelpCenter();
  const primaryFooterLink = helpCenter?.footer?.footer_links?.find(
    (footer) => footer.type === FooterLinkType.REP_CHAT_PRIMARY
  );
  const secondaryFooterLink = helpCenter?.footer?.footer_links?.find(
    (footer) => footer.type === FooterLinkType.REP_CHAT_SECONDARY
  );
  return { primaryFooterLink, secondaryFooterLink };
}
